import React, { useEffect, useState } from "react";
import "./SearchHistoryKeyword.less";
import IconFont from "@/components/icon";
import { isJSON } from "@/utils/tools";
import logger from "@/utils/logger";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
const log = logger.getLogger("SearchGlobalModal");
const SearchHistoryKeyword = ({
  setSearchGlobalValue
}: {
  setSearchGlobalValue?: (value: string) => void;
}) => {
  const { t } = useTranslation("common");
  const { authInfo: authData } = React.useContext<GlobalContextConfig>(GlobalContext);
  const globalSearchId =
    authData?.userId +
    "-" +
    authData?.ddAppId +
    "-" +
    authData?.teamUserInfo?.teamId +
    "-search-keyword";
  const globalSearchKeyword = localStorage.getItem(globalSearchId);
  const [globalSearchKeywordList, setGlobalSearchKeywordList] = useState([]);
  useEffect(() => {
    if (globalSearchKeyword && isJSON(globalSearchKeyword)) {
      setGlobalSearchKeywordList(JSON.parse(globalSearchKeyword));
    }
  }, [globalSearchKeyword]);
  return Array.isArray(globalSearchKeywordList) && !!globalSearchKeywordList.length ? (
    <div className="global-search-history">
      <div className="header">
        <label>搜索历史</label>
        <IconFont
          className="delete"
          type="iconic_app_im_delete1"
          onClick={() => {
            Modal.confirm({
              content: t("search.clearAllSearchHistory"),
              okText: t("button.ok"),
              cancelText: t("button.cancel"),
              onOk: () => {
                localStorage.setItem(globalSearchId, JSON.stringify([]));
                setGlobalSearchKeywordList([]);
              }
            });
          }}
        />
      </div>
      <div className="tags">
        {globalSearchKeywordList.map((value: string, index: number) => {
          return (
            <span
              key={"history-search-keyword-" + index}
              onClick={() => {
                setSearchGlobalValue?.(value);
              }}
            >
              {value}
            </span>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default SearchHistoryKeyword;
